import { useEffect } from 'react';
import Lenis from 'lenis';
import { useExperience, isWebsite } from '@/store/experience';
import { setLenis } from '@/lib/scroll';
import { HeroSection } from '@/sections/HeroSection';
import { Marquee } from '@/sections/Marquee';
import { ServicesSection } from '@/sections/ServicesSection';
import { WebsiteServices } from '@/sections/WebsiteServices';
import { PortfolioSection } from '@/sections/PortfolioSection';
import { AboutSection } from '@/sections/AboutSection';
import { ProjectRequest } from '@/sections/ProjectRequest';
import { ContactSection } from '@/sections/ContactSection';

const SECTION_IDS = ['home', 'services', 'websites', 'portfolio', 'about', 'start', 'contact'];

export function Website() {
  const phase = useExperience((s) => s.phase);
  const live = isWebsite(phase);

  useEffect(() => {
    if (!live) return;
    const st = useExperience.getState();
    const lenis = new Lenis({ lerp: 0.085, smoothWheel: true, wheelMultiplier: 0.9 });
    setLenis(lenis);
    let last = 0;
    lenis.on('scroll', ({ progress }) => {
      st.frame.scroll = progress;
      const now = performance.now();
      if (now - last > 80) { last = now; st.setScroll(progress); }
    });
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);

    const obs = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) st.setActiveSection(e.target.id); });
    }, { rootMargin: '-45% 0px -45% 0px' });
    SECTION_IDS.forEach((id) => { const el = document.getElementById(id); if (el) obs.observe(el); });
    return () => { cancelAnimationFrame(raf); lenis.destroy(); setLenis(null); obs.disconnect(); };
  }, [live]);

  return (
    <main className="relative z-10" data-testid="website-root">
      <HeroSection />
      <Marquee />
      <ServicesSection />
      <WebsiteServices />
      <PortfolioSection />
      <AboutSection />
      <ProjectRequest />
      <ContactSection />
    </main>
  );
}
